/**
 * @generated SignedSource<<b785ca02dba1ef48688d33cdecf86e44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportHubDetailedSkillReportByUnitsColumnsQuery$variables = {
  classIds: ReadonlyArray<string>;
  skip?: boolean | null | undefined;
  standardStateId: string;
  targetGroupId: string;
};
export type ReportHubDetailedSkillReportByUnitsColumnsQuery$data = {
  readonly skillProgressReportGroupedByUnitsInBytes?: {
    readonly data: ReadonlyArray<any>;
  };
};
export type ReportHubDetailedSkillReportByUnitsColumnsQuery = {
  response: ReportHubDetailedSkillReportByUnitsColumnsQuery$data;
  variables: ReportHubDetailedSkillReportByUnitsColumnsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classIds"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "standardStateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupId"
},
v4 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Variable",
            "name": "standardStateId",
            "variableName": "standardStateId"
          },
          {
            "kind": "Variable",
            "name": "targetGroupId",
            "variableName": "targetGroupId"
          }
        ],
        "concreteType": "ExportableReport",
        "kind": "LinkedField",
        "name": "skillProgressReportGroupedByUnitsInBytes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubDetailedSkillReportByUnitsColumnsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportHubDetailedSkillReportByUnitsColumnsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0d3ae5e450799f41ac7ca466228b9a19",
    "id": null,
    "metadata": {},
    "name": "ReportHubDetailedSkillReportByUnitsColumnsQuery",
    "operationKind": "query",
    "text": "query ReportHubDetailedSkillReportByUnitsColumnsQuery(\n  $classIds: [ID!]!\n  $targetGroupId: ID!\n  $standardStateId: ID!\n  $skip: Boolean = true\n) {\n  skillProgressReportGroupedByUnitsInBytes(classIds: $classIds, targetGroupId: $targetGroupId, standardStateId: $standardStateId) @skip(if: $skip) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "2799a09125ea25e752e786882a7d8abc";

export default node;
